import * as Icon from 'react-feather';
import React from 'react';
import PropTypes from 'prop-types';

const QtySelector = ({
  value,
  onClickPlus,
  onClickMinus,
  iconSize,
  className,
}) => {
  return (
    <div className={`d-flex align-items-center ${className}`}>
      <Icon.MinusSquare
        size={iconSize || 24}
        className="primary"
        onClick={() => value && onClickMinus()}
      />
      <span className="font-medium-1 text-center" style={{ width: '2.25rem' }}>
        {value}
      </span>
      <Icon.PlusSquare
        size={iconSize || 24}
        className="primary"
        onClick={onClickPlus}
        data-test="testAddAddition"
      />
    </div>
  );
};

QtySelector.propTypes = {
  value: PropTypes.number,
  onClickPlus: PropTypes.func,
  onClickMinus: PropTypes.func,
  iconSize: PropTypes.number,
  className: PropTypes.string,
};

export default QtySelector;
